import React from "react";

interface IconButtonProps {
  Icon: (props: React.ComponentProps<"svg">) => JSX.Element;
  label?: string;
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
}

const IconButton: React.FC<IconButtonProps> = ({
  Icon,
  label,
  className,
  iconClassName,
  onClick,
}) => {
  return (
    <button
      className={`flex items-center gap-2 ${className}`}
      onClick={onClick}>
      <Icon className={`primary-icon ${iconClassName}`} />
      <p className="hidden md:block capitalize font-medium">{label}</p>
    </button>
  );
};

export default IconButton;
